<template>
  <div class="keyOpenDoor">
    <div>
      <div class="icon el-icon-circle-check-outline"></div>
      <div class="nameKey">已经为您打开箱格</div>
      <div class="tips">请取走钥匙后随手关门</div>
      <!-- <div class="tips mt20" v-if="isOverTips = true">{{time2}}秒后若箱门未关，系统将自动开始盘点</div> -->
    </div>
    <currtime :isShowInfo="false"></currtime>
    <template v-if="isError == true">
      <div class="tipDio">
        <div class="name">检测到箱门未关</div>
        <div class="name">请确认箱门是否关闭</div>
        <div class="tips"><b>{{time}}秒</b></div>
        <!-- <div class="backbtn"><el-button @click="backUp">返回</el-button></div> -->
      </div>
      <div class="bgDiv"></div>
    </template>

    <template v-if="isEnd == true">
      <div class="tipDio">
        <div class="name" v-if="keyNum == 0 &&  keyNum2 ==0">您没有任何操作</div>
        <template v-else-if="keyNum > 0 && keyNum2 == 0">
          <div class="name">您已取走{{keyNum}}把钥匙</div>
          <div class="name">欢迎下次光临</div>
        </template>
        <template v-else-if="keyNum == 0 && keyNum2 > 0">
          <div class="name colF56">您已归还{{keyNum2}}把钥匙</div>
          <div class="name">欢迎下次光临</div>
        </template>
        <template v-else-if="keyNum > 0 && keyNum2 > 0">
          <div class="name">您已取走{{keyNum}}把钥匙,<span class="colF56">归还{{keyNum2}}把钥匙</span></div>
          <div class="name">欢迎下次光临</div>
        </template>
        <!-- <template v-else>
        <div class="name">你已取走{{keyNum}}把钥匙</div>
        <div class="name">请妥善保管</div>
        </template> -->
        <div class="tips"><b>{{time}}秒</b></div>
        <!-- <div class="backbtn"><el-button @click="backUp">返回</el-button></div> -->
      </div>
      <div class="bgDiv"></div>
    </template>
  </div>
</template>

<script>
import currtime from '../../../assets/currTime'
import { checkData } from '../../../../static/js/utils/util.js'
import { borrowApi,keyCabinetApi } from "../../../../static/js/api.js"
import { text2Audio,storage,localUserInfo,conLog,getMp3 } from '../../../../static/js/utils/utility.js'
import * as config from '../../../../static/js/config.js';
import qs from 'qs'
import noDoMp3 from '../../../../static/mp3/noDo.mp3'
import checkCloseMp3 from '../../../../static/mp3/checkClose.mp3'
import openKeyMp3 from '../../../../static/mp3/openKey.mp3'
import nyqz from '../../../../static/mp3/nyqz.mp3'
import nygh from '../../../../static/mp3/nygh.mp3'
import byshyxcgl from '../../../../static/mp3/byshyxcgl.mp3'
import bysgh from '../../../../static/mp3/bysgh.mp3'
import {websocketsend} from  '../../../../static/js/utils/socket.js'
export default {
  name: 'keyOpenDoor',
  data () {
    return {
      keyId:'',

      isFirst:false,

      isError:false,//未拉开门弹窗
      time:5,
      timeStatus:'',

      overtime:60,//门超时未关
      overtimeStatus:'',

      time2:30,//二次超时返回
      timeStatus2:'',
      isTime2:false,

      isEnd:false,//门关上弹窗
      keyNum:0,//拿走的钥匙数量
      keyNum2:0,//归还的钥匙数量

      keyStatus:'',

      cellsList:[],

      keyStatusFirst:false,//判断是否第二次调用getKeyStatus方法

      statusNum:0,//获取所有锁状态的调用次

    }
  },
  mounted(){

  },
  created(){
    var that = this
    this.keyId = storage.sessionGetItem('keyCheck')
    for(var i in this.keyId){
      this.openKey(this.keyId[i])
    }
    // this.keyStatus = setInterval(function(){
    //   that.getKeyStatus()
    // },1000)
  },
  components:{
    currtime,
  },
  methods:{
    //mp3==>把钥匙，欢迎下次光临
    nextMp3(){
      var url = byshyxcgl
      var audio = new Audio(url);
      audio.src = url;
      audio.play();
    },
    //mp3==>把钥匙，归还
    nextMp3_2(num2){
      var url = bysgh
      var audio = new Audio(url);
      audio.src = url;
      audio.play();
      audio.addEventListener('ended', function () {
        getMp3(num2.toString(),() =>{
          that.nextMp3()
        })
      }, false);
    },
    //接收socket
    getSkMsg(res){
      var that = this;
      if(res.error == 0){
        if(res.fun_code == 'E501'){
          //判断大门是否打开
          if(res.ext_lock_status == '2'){
            
            //判断是否第一次调用
            // if(that.isFirst == false){
            // if(that.statusNum == 1){
            if(that.keyId.length == 0){
              //大门开门语音
              var url = openKeyMp3
              var audio = new Audio(url);
              audio.src = url;
              audio.play();
              that.overTime(that.overtime)
              that.cellsList = res.cells
            }
            // that.isFirst = true
            that.statusNum += 1
          // }else if(res.ext_lock_status == '1' && that.isFirst == false){
          }else if(res.ext_lock_status == '1' && that.statusNum == 0){
            if(that.keyStatusFirst == false){
              that.overtime2(that.time2)
            }
          // }else if(res.ext_lock_status == '1' && that.isFirst == true){
          }else if(res.ext_lock_status == '1' && that.statusNum >= 1){
            clearInterval(that.keyStatus)
            clearTimeout(that.overtimeStatus)
            if(that.isTime2 == true){
              clearTimeout(that.timeStatus2)
            }
            //计算不在库数量
            var num = 0
            var num2 = 0
            var arr = storage.sessionGetItem('keyCheck')
            var arr2 = res.cells
            var arr3 = that.cellsList
            conLog('cells',arr2)
            conLog('cellsList',arr3)
            for(var i in arr2){
              for(var y in arr){
                if(arr2[i].cell_id == arr[y]){
                  if(arr2[i].lock_status == 2){
                    num+=1
                  }
                }
              }
            }
            for(var i in arr3){
              for(var x in arr2){
                if(arr2[x].cell_id == arr3[i].cell_id){
                  if(arr3[i].lock_status == 2 && arr2[x].lock_status == 1){
                    num2+=1
                  }
                }
              }
            }
            that.keyNum = num
            that.keyNum2 = num2
            //语音
            if(num == 0 && num2 == 0){
              //您没有任何操作
              var url = noDoMp3
              var audio = new Audio(url);
              audio.src = url;
              audio.play();
            }else if(num > 0 && num2 == 0){
              //语音
              // text2Audio('您已取走'+num+'把钥匙，欢迎下次光临')
              var url = nyqz
              var audio = new Audio(url);
              audio.src = url;
              audio.play();
              audio.addEventListener('ended', function () {
                getMp3(num.toString(),() =>{
                  that.nextMp3()
                })
              }, false);
            }else if(num == 0 && num2 > 0){
              //语音
              // text2Audio('您已归还'+num2+'把钥匙，欢迎下次光临')
              var url = nygh
              var audio = new Audio(url);
              audio.src = url;
              audio.play();
              audio.addEventListener('ended', function () {
                getMp3(num2.toString(),() =>{
                  that.nextMp3()
                })
              }, false);
            }else if(num > 0 && num2 > 0){
              // text2Audio('您已取走'+num+'把钥匙，归还'+num2+'把钥匙，欢迎下次光临')
              var url = nyqz
              var audio = new Audio(url);
              audio.src = url;
              audio.play();
              audio.addEventListener('ended', function () {
                getMp3(num.toString(),() =>{
                  that.nextMp3_2(num2)
                })
              }, false);
            }
            //打开提示框并且倒计时
            that.isEnd = true;
            that.time = 5
            that.getSecond(that.time)
          }
          this.keyStatusFirst = true
        }
      }
    },
    //开门超时
    overTime(wait){
      var that = this;
      var _wait = wait;
      if(wait == 0) {
        wait = _wait;
        clearTimeout(that.overtimeStatus)
        that.isError = true;
        that.getSecond(that.time)
        var url = checkCloseMp3
        var audio = new Audio(url);
        audio.src = url;
        audio.play();
        that.isTime2 = true
        that.overtime2(that.time2)
      } else {
        this.overtime=wait
        wait--;
        that.overtimeStatus = setTimeout(function() {
          that.overTime(wait);
        },1000);
      }
    },
    //二次超时返回
    overtime2(wait){
      conLog('keyOpenovertime2',wait)
      var that = this;
      var _wait = wait;
      if(wait == 0) {
        wait = _wait;
        clearInterval(that.keyStatus)
        clearTimeout(that.timeStatus2)
        that.backUp()
      } else {
        that.time2=wait
        that.time2--;
        that.timeStatus2 = setTimeout(function() {
          that.overtime2(that.time2);
        },1000);
      }
    },
    //开锁(单个)
    async openKey(keyId){
      var that = this;
      var dataObj = {
        'open': parseInt(keyId),
        // 'cabinet_id': config.deviceId,
        // 'type': '1'
      }
      var res = await keyCabinetApi.openKey(qs.stringify(dataObj))
      if(res.error == 0 ){
        that.keyId.splice(0,1)
      }else{
        // this.$message.error(res.meta.$message)
        this.$message.error('开锁异常！')
      }
    },
    //获取锁状态
    async getKeyStatus(){
      var that = this;
      var dataObj = {
        'status': 'all',
      }
      var res = await keyCabinetApi.openKey(qs.stringify(dataObj))
      if(res.error == 0 ){
        //判断大门是否打开
        if(res.ext_lock_status == '2'){
          
          //判断是否第一次调用
          // if(that.isFirst == false){
          // if(that.statusNum == 1){
          if(that.keyId.length == 0){
            //大门开门语音
            var url = openKeyMp3
            var audio = new Audio(url);
            audio.src = url;
            audio.play();
            that.overTime(that.overtime)
            that.cellsList = res.cells
          }
          // that.isFirst = true
          that.statusNum += 1
        // }else if(res.ext_lock_status == '1' && that.isFirst == false){
        }else if(res.ext_lock_status == '1' && that.statusNum == 0){
          if(that.keyStatusFirst == false){
            that.overtime2(that.time2)
          }
        // }else if(res.ext_lock_status == '1' && that.isFirst == true){
        }else if(res.ext_lock_status == '1' && that.statusNum >= 1){
          clearInterval(that.keyStatus)
          clearTimeout(that.overtimeStatus)
          if(that.isTime2 == true){
            clearTimeout(that.timeStatus2)
          }
          //计算不在库数量
          var num = 0
          var num2 = 0
          var arr = storage.sessionGetItem('keyCheck')
          var arr2 = res.cells
          var arr3 = that.cellsList
          conLog('cells',arr2)
          conLog('cellsList',arr3)
          for(var i in arr2){
            for(var y in arr){
              if(arr2[i].cell_id == arr[y]){
                if(arr2[i].lock_status == 2){
                  num+=1
                }
              }
            }
          }
          for(var i in arr3){
            for(var x in arr2){
              if(arr2[x].cell_id == arr3[i].cell_id){
                if(arr3[i].lock_status == 2 && arr2[x].lock_status == 1){
                  num2+=1
                }
              }
            }
          }
          that.keyNum = num
          that.keyNum2 = num2
          //语音
          if(num == 0 && num2 == 0){
            //您没有任何操作
            var url = noDoMp3
            var audio = new Audio(url);
            audio.src = url;
            audio.play();
          }else if(num > 0 && num2 == 0){
            //语音
            // text2Audio('您已取走'+num+'把钥匙，欢迎下次光临')
            // var url = '../../../../static/mp3/backKeyEnd.mp3'
            // var audio = new Audio(url);
            // audio.src = url;
            // audio.play();
          }else if(num == 0 && num2 > 0){
            //语音
            // text2Audio('您已归还'+num2+'把钥匙，欢迎下次光临')
          }else if(num > 0 && num2 > 0){
            // text2Audio('您已取走'+num+'把钥匙，归还'+num2+'把钥匙，欢迎下次光临')
          }
          //打开提示框并且倒计时
          that.isEnd = true;
          that.time = 5
          that.getSecond(that.time)
        }
        this.keyStatusFirst = true
      }else{
        // this.$message.error(res.meta.$message)
        this.$message.error('获取异常！')
      }
    },
    //倒计时
    getSecond(wait){
      var that = this;
      var _wait = wait;
      if(wait == 0) {
        wait = _wait;
        clearTimeout(that.timeStatus)
        if(that.isError == true){
          that.isError = false
        }
        if(that.isEnd == true){
          that.backUp()
        }
      } else {
        that.time=wait
        that.time--;
        that.timeStatus = setTimeout(function() {
          that.getSecond(that.time);
        },1000);
      }
    },
    //返回
    backUp(){
      // clearTimeout(this.timeStatus)
      // clearTimeout(this.overtimeStatus)
      this.isError = false;
      storage.sessionRemoveItem('keyCheck')
      this.$router.push({
        // path:'/keyCabinet/keyBorrow'
        path:'/keyCabinet'
      })
    },
  },
  watch :{
    "$store.state.wsMsg":function(newVal){
      this.getSkMsg(newVal)
    }
  },
}
</script>

<style lang="less">
.keyOpenDoor{
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  // background: url('../../../../../../static/images/bg.jpg') center no-repeat;
  // background-size: cover;
  .icon{
    color: #4babfe;
    font-size: 2rem;
  }
  .nameKey{
    font-size: 0.5rem;
    margin: 0.8rem 0 0.27rem;
    span{color:#fff;}
  }
  .tips{
    font-size: 0.36rem;
    color: #e2dfdf;
  }
  .tipDio{
    width: 50%;
    position: fixed;
    top: 10%;
    left:50%;
    margin-left: -25%;
    background: #fff;
    color: #333;
    z-index: 100;
    border-radius: 0.1rem;
    padding:0.4rem;
    box-sizing: border-box;
    .name{
      text-align: left;
      font-size: 0.5rem;
      margin-bottom: 0.2rem;
      // padding-left: 0.4rem;
      // margin: 0.4rem 0;
    }
    .colF56{
      color: #F56C6C;
    }
    .tips{
      font-size: 0.3rem;
    }
    .backbtn{
      text-align: right;
      margin: 0.2rem 0.4rem 0rem;
      .el-button{
        height: 0.94rem;
        width: 2.54rem;
        padding: 0;
        // margin: 0 1.2rem;
        font-size: 0.4rem;
        color: #fff;
        font-weight: bold;
        border: none;
        border-radius: 0.12rem;
        line-height:0.94rem;
        background: linear-gradient(#4aaafe, #0769be);
      }
    }
  }
  .bgDiv{
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    z-index: 99;
    left: 0;
    right: 0;
    top: 0;
    bottom:0;
  }
  .currTime{
    position: absolute;
    right: 0.2rem;
    top: 0.2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/keyCabinet/keyBorrow/keyOpenDoor.vue